<template>
  <div class="audience-overview-chart p-4 rounded-lg shadow-sm bg-white">
    <div class="flex items-center justify-end mb-2">
      <ChartSelect v-model="yAxisField" />
    </div>
    <div class="chart-container mb-6">
      <EchartCon
        :data="chartData"
        :yAxisField="yAxisField"
      />
    </div>

    <CommonTable
      :table-data="tableData"
      :name-column-props="{
        prop: 'name',
        label: '受众群体名称',
        width: '160px',
      }"
      :show-status="true"
      :show-type="true"
      :currency="currency"
    >
      <template #nameColumn="{ row }">
        <p>{{ showParentName(row) }}</p>
        <p>{{ row.name }}</p>
      </template>
    </CommonTable>
  </div>
</template>

<script>
import ChartSelect from './ChartSelect.vue';
import EchartCon from './EchartCon.vue';
import CommonTable from './CommonTable.vue';
import { getTableData } from '../index';
export default {
  name: 'AudienceSegmentChart',
  props: {
    // 接收父组件传递的数据
    data: {
      type: Object,
      default: () => {
        return {
          detailReports: {},
          summaryMetrics: {},
          estimateMetrics: {},
          adGroupMetrics: {},
          currencySign: '$',
        };
      },
    },
  },
  components: {
    ChartSelect,
    EchartCon,
    CommonTable,
  },
  data() {
    return {
      yAxisField: ['spend', 'conversions'],
    };
  },
  computed: {
    currency() {
      return this.data?.currencySign || '$';
    },
    chartData() {
      return this.data?.segmentMetrics || [];
    },
    tableData() {
      console.log(getTableData(this.data), '111');
      return getTableData(this.data);
    },
  },
  methods: {
    showParentName(row) {
      console.log(row.fullName, 'row.fullNamerow.fullNamerow.fullNamerow.fullName');
      return row.fullName?.substring(0, row.fullName.lastIndexOf('/'));
    },
  },
};
</script>

<style scoped>
/* 使用 scoped style 确保样式只应用于当前组件 */
/* 可以添加一些自定义样式来覆盖 Element UI 默认样式，以实现更贴合截图的视觉效果 */
:deep(.el-table th) {
  /* 模拟截图中的表头背景色，虽然 Element UI 的默认颜色接近，但可以微调 */
  background-color: #f7f9fb !important;
  color: #606266;
  font-weight: bold;
}
/* 模拟截图中的高亮行，这里特指 “总计 (广告组)” 的蓝色高亮行 */
:deep(.el-table .el-table__row:last-child) {
  /* 实际项目中，你需要通过 row-class-name 或 row-style 来动态判断并应用样式 */
  /* 这里为了还原截图，我们暂时对最后一行应用样式 */
  /* background-color: #f0f8ff; /* 浅蓝色背景 */
  /* font-weight: bold; */
}
</style>
